import * as React from "react"
import Layout from "../components/layout"

const RegularPage = ({ location, children }) => {
  return (
    <Layout location={location}>
      <div className="pagelayout-main-heading-wrapper">
        <h1 className="pagelayout-main-heading">{`>/-`}</h1>
      </div>
      {children}
    </Layout>
  )
}

export default RegularPage
